module.exports = __webpack_public_path__ + "img/logo-iris.824c734d.png";